// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Ima6","header":"PatientBlock_header__n0Iy9","label":"PatientBlock_label__27_hE","option":"PatientBlock_option__3vxsG"};